import type { Skin } from 'c-entity-types';

const SELECTED_SKIN_KEY = 'selected-fe-skin';
const SELECTED_PRE_IMPERSONATION_SKIN_KEY = 'selected-pre-impersonate-fe-skin';
const SELECTED_SKIN_USER_KEY_PREFIX = 'selected-fe-skin-user-';

const getUserSkinKey = (userId: number | string) => `${SELECTED_SKIN_USER_KEY_PREFIX}${userId}`;

/** The skin stored under `key`: null when nothing is stored, undefined when it isn't valid JSON. */
const readStoredSkin = (key: string): Skin | null | undefined => {
    try {
        return JSON.parse(localStorage.getItem(key) ?? 'null');
    } catch (e) {
        return undefined;
    }
};

export const getDefaultSkin = (): Skin | null | undefined =>
    localStorage != null ? readStoredSkin(SELECTED_SKIN_KEY) : undefined;

export const getDefaultSkinForUser = (userId?: number | string): Skin | null | undefined => {
    if (!userId || localStorage == null) {
        return undefined;
    }
    return readStoredSkin(getUserSkinKey(userId));
};

export const storeDefaultSkinForUser = (userId?: number | string, skin?: Skin) => {
    if (!userId || localStorage == null) {
        return;
    }
    const key = getUserSkinKey(userId);
    if (skin == null) {
        localStorage.removeItem(key);
        return;
    }
    localStorage.setItem(key, JSON.stringify(skin));
};

export const getPreImpersonateSkin = (): Skin | null | undefined =>
    localStorage != null ? readStoredSkin(SELECTED_PRE_IMPERSONATION_SKIN_KEY) : undefined;

export const storePreImpersonateSkin = (skin?: Skin) => {
    if (localStorage != null) {
        localStorage.setItem(SELECTED_PRE_IMPERSONATION_SKIN_KEY, JSON.stringify(skin));
    }
};

export const storeDefaultSkin = (skin: Skin) => {
    if (localStorage != null) {
        localStorage.setItem(SELECTED_SKIN_KEY, JSON.stringify(skin));
    }
};
